import * as _ from "lodash";
import * as React from "react";
import {
  Column,
  TableCellRenderer,
  CellInfo
} from "react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import TableLink from "src/library/components/Tables/TableLink";
import { InstalledModuleType } from "src/utils/constants";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { formatPrice } from "src/core/prices/utils/price-helpers";
import { IPrice } from "src/core/shared/api/price-change.api";

export interface IPriceListProductsTable {
  ActionButton?: TableCellRenderer;
  prices: IPrice[];
  priceCodeId: number | null;
  terminology: ITerminology
}

export const priceChangeProductsTableColumns = (params: IPriceListProductsTable, installedModules: InstalledModuleType[]): Column[] => {
  const hasPriceChangeModule = installedModules.includes("price-change");

  const columns: Column[] = [
    globalTableColumns.standardText({
      Header: "Name",
      accessor: "product.description",
      filterable: false,
      sortable: false,
      Cell: (cellProps: CellInfo) => {
        if (cellProps.value) {
          return (
            <TableLink to={`/products/${cellProps.original.productId}`}>
              {cellProps.value}
            </TableLink>
          );
        }

        return null;
      }
    }),
    globalTableColumns.standardText({
      Header: params.terminology?.partNumber.singular.text || "Part number",
      accessor: "product.partNumber",
      sortable: false,
      filterable: false
    }),
    {
      Header: "Selling Price",
      accessor: "price",
      sortable: false,
      filterable: false,
      Cell: props => {
        return `${formatPrice(props.value)}`;
      }
    },
    globalTableColumns.standardText({
      Header: "VAT Percentage",
      accessor: "vatPercentage",
      sortable: false,
      filterable: false,
      Cell: props => {
        return `${props.value}%`;
      }
    }),
    globalTableColumns.standardText({
      Header: "VAT Value",
      accessor: "vatValue",
      sortable: false,
      filterable: false,
      Cell: props => {
        return `${formatPrice(props.value)}`;
      }
    }),
    globalTableColumns.standardText({
      Header: "Effective date",
      accessor: "effectiveDate",
      sortable: false,
      filterable: false
    }),
    globalTableColumns.standardText({
      Header: "End date",
      accessor: "endDate",
      sortable: false,
      filterable: false
    })
  ];

  if (!hasPriceChangeModule && params.ActionButton) {
    columns.push(globalTableColumns.actions({ cell: params.ActionButton }));
  }

  return columns;
};
